import angular from 'angular';
import { LeadActivitiesReportComponent } from './lead-activities-report/lead-activities-report.component';
import { LeadsConversionDetailReportComponent } from './leads-conversion-report/leads-conversion-detail-report.component';
import { LeadsConversionReportComponent } from './leads-conversion-report/leads-conversion-report.component';

export const LeadReportsModule = angular
    .module("apex.mainApp.leads.reports", [])
    .component("apexLeadsActivitiesReport", LeadActivitiesReportComponent)
    .component("apexLeadsConversionDetailReport", LeadsConversionDetailReportComponent)
    .component("apexLeadsConversionReport", LeadsConversionReportComponent)
    .name;

